<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            {{ objeto_busqueda.codigo }}
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-2">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                            <thead>
                                <tr>
                                    <th>
                                        Sucursal
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in formulas" :key="index">
                                    <td>
                                        {{ item.nombre_sucursal }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'FichaFormula',
        computed: {
            ...mapState(['objeto_busqueda', 'modal_cambio_precios', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                formulas: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async buscar_formulas() {
                let f = {
                    api: `articulos/c/formulas?codigo=${this.objeto_busqueda.codigo}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                this.formulas = r
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            this.buscar_formulas()
        },
    }
</script>

<style></style>